import React, { useRef, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import useDialog from '../../hooks/useDialog';

const CustomSelect = ({ label, productDetailData, onSelect }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [, setSelectedOption] = useState(null);
  const selectRef = useRef(null);
  const { t } = useTranslation();
  const { showDialog } = useDialog();
  const { items, price, currency } = productDetailData;

  const handleClickAlertDialog = () => {
    showDialog({
      dialogType: 'AlertDialog',
      dialogProps: {
        title: t('sold_out_msg'),
        confirmText: t('confirm'),
      },
    });
  };

  const handleSelectClick = () => {
    setIsOpen(!isOpen);
  };

  const handleOptionClick = (option) => {
    if (option.is_soldout) {
      setIsOpen(false);
      handleClickAlertDialog();
      return;
    } else {
      setSelectedOption(option);
      setIsOpen(false);
      // 옵션 선택 시 onSelect 콜백 호출
      if (onSelect) {
        onSelect(option);
      }
    }
  };

  const handleOutsideClick = (event) => {
    if (selectRef.current && !selectRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleOutsideClick);
    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, []);

  return (
    <div className={`custom-select-wrapper ${isOpen ? 'is-open' : ''}`} ref={selectRef}>
      {label ? <label className={'custom-select-label'}>{label}</label> : null}

      <div className='custom-select-content-group'>
        <div className='custom-select-header-group cursor-pointer' onClick={handleSelectClick}>
          <p className={'custom-select-header-value'}>{t('select')}</p>
          <span className={'custom-select-header-icon-group'}>
            <i className={'icon icon-dropdown'} />
          </span>
        </div>
        {isOpen && (
          <ul className={'custom-select-option-group item-custom-scroll'}>
            {items?.map((option) => (
              <li
                key={option.item_id}
                className={`custom-select-option-list cursor-pointer ${option.is_soldout ? 'is-soldout' : null}`}
                onClick={() => {
                  handleOptionClick(option);
                }}
              >
                {option.item_name}
                {/* 차액 계산: 옵션 가격 - 옵션 중 최저 가격 */}
                &nbsp;(+{(option.item_price - price).toLocaleString()}
                {/* 품절인 경우 [Sold out] 문구 표기 */}
                &nbsp;{currency}) {option.is_soldout ? `[${t('sold_out')}]` : null}
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default CustomSelect;
